import type { NumberInventoryListingConfig } from "@dealer-center/ddc-pages-inventory-config-interface";
import type { baseInputs } from "./base";

type numberInputsListFlat = Record<NumberListType, numberInputs>;

export interface numberInputs extends baseInputs {
  type: "number";
  autoInsertCommas: boolean;
  default: number;
}
export type NumberListType = keyof NumberInventoryListingConfig;

export const numberInputsListFlat: numberInputsListFlat = {
  status: {
    type: "number",
    dataIndex: "status",
    label: "Status",
    default: 0,
    autoInsertCommas: false
  },
  charLimit: {
    type: "number",
    dataIndex: "charLimit",
    label: "Char Limit",
    default: 0,
    autoInsertCommas: false
  },

  pageSize: {
    type: "number",
    dataIndex: "pageSize",
    label: "Page Size",
    default: 35,
    autoInsertCommas: false
  },
  visiblePageCount: {
    type: "number",
    dataIndex: "visiblePageCount",
    label: "Visible Page Count",
    default: 10,
    autoInsertCommas: false
  },
  baseCityMPG: {
    type: "number",
    dataIndex: "baseCityMPG",
    label: "Base City MPG",
    default: 0,
    autoInsertCommas: false
  },
  baseHighwayMPG: {
    type: "number",
    dataIndex: "baseHighwayMPG",
    label: "Base Highway MPG",
    default: 0,
    autoInsertCommas: false
  },
  priceCap: {
    type: "number",
    dataIndex: "priceCap",
    label: "Price Cap",
    autoInsertCommas: true,
    default: 0
  },
  yearCap: {
    type: "number",
    dataIndex: "yearCap",
    label: "Year Cap",
    default: 0,
    autoInsertCommas: false
  },
  minLotDays: {
    type: "number",
    dataIndex: "minLotDays",
    label: "Min Lot Days",
    default: 0,
    autoInsertCommas: false
  },
  sharedMinLotDays: {
    type: "number",
    dataIndex: "sharedMinLotDays",
    label: "Shared Min Lot Days",
    default: 0,
    autoInsertCommas: false
  },

  calcRate: {
    type: "number",
    dataIndex: "calcRate",
    label: "Calc Rate",
    default: 6.0,
    autoInsertCommas: false
  },
  calcMaxTerm: {
    type: "number",
    dataIndex: "calcMaxTerm",
    label: "Calc Max Term",
    default: 60,
    autoInsertCommas: false
  },
  calcCashTrade: {
    type: "number",
    dataIndex: "calcCashTrade",
    label: "Calc Cash Trade",
    default: 2000,
    autoInsertCommas: true
  },
  calcInterval: {
    type: "number",
    dataIndex: "calcInterval",
    label: "Calc Interval",
    default: 12,
    autoInsertCommas: false
  },

  calcSelectedTerm: {
    type: "number",
    dataIndex: "calcSelectedTerm",
    label: "Calc Selected Term",
    default: 60,
    autoInsertCommas: false
  },
  priceFloor: {
    type: "number",
    dataIndex: "priceFloor",
    label: "Price Floor",
    autoInsertCommas: true,
    default: 0
  },
  priceEndsWith: {
    type: "number",
    dataIndex: "priceEndsWith",
    label: "Price Ends With",
    autoInsertCommas: true,
    default: 0
  },
  mileageCap: {
    type: "number",
    dataIndex: "mileageCap",
    label: "Mileage Cap",
    default: 0,
    autoInsertCommas: false
  },
  mileageFloor: {
    type: "number",
    dataIndex: "mileageFloor",
    label: "Mileage Floor",
    default: 0,
    autoInsertCommas: false
  },
  maxLotDays: {
    type: "number",
    dataIndex: "maxLotDays",
    label: "Max Lot Days",
    default: 0,
    autoInsertCommas: false
  },
  yearFloor: {
    type: "number",
    dataIndex: "yearFloor",
    label: "Year Floor",
    default: 0,
    autoInsertCommas: false
  }
};

export const isNumberInput = (input: baseInputs): input is numberInputs => {
  return input.type === "number";
};
